export default "__VITE_ASSET__D15EL9Tm__"